import React from 'react';
import { triggerChatWidgetPositionCalculation } from '../utils/triggerChatWidgetPositionCalculation';

export function useRecalculateChatWidgetPositionOnMounAndUnmount() {
  React.useEffect(() => {
    triggerChatWidgetPositionCalculation();
    return triggerChatWidgetPositionCalculation;
  }, []);
}
